import { Component, Output, EventEmitter, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, AfterViewInit {
  isMobile: boolean = false;
  public isCollapsed: boolean = true;

  public environment = environment;
  public roles: any = undefined;
  private currentUser = JSON.parse(localStorage.getItem('user'));


  constructor(private authService: AuthService,
    private cdr: ChangeDetectorRef
  ) {}


  checkIfMobile() {
    this.isMobile = window.innerWidth <= 768;
  }

  ngOnInit() {
    // if (isPlatformBrowser(this.platformId) && window.innerWidth < 968) {
    //   this.mobile = true;
    // }
    this.authService.getRoles().subscribe({
      next: response => {
        this.roles = response.data;
      }
    })
    this.checkIfMobile();
    window.addEventListener('resize', this.checkIfMobile.bind(this));
  }

  ngAfterViewInit() {
    this.isCollapsed = this.isMobile ? true : false;
    this.collapsedChange.emit(this.isCollapsed);
    this.cdr.detectChanges();
  }
  public navLinks: Array<NavigationLinks> = [
    {
      title: $localize`Principal`,
      icon: 'assets/svgs/menu_nav.svg',
      href: ["/platform", "init", "."],
      includes: ['is_user'],
      mobile: true
    },
    {
      title: $localize`Principal`,
      icon: 'assets/svgs/menu_nav.svg',
      href: ["/admin", "init", "."],
      mobile: true,
      includes: ['is_admin', 'is_coach', 'is_therapist', 'is_intermediary']
    },
    {
      title: $localize`Clientes`,
      icon: 'assets/svgs/clients_nav.svg',
      href: ["/admin", "clients", "."],
      mobile: true,
      includes: ['is_admin', 'is_coach', 'is_therapist', 'is_intermediary'],
      childs: [
        {
          title: $localize`Seguimiento`,
          icon: 'assets/svgs/followup_nav.svg',
          href: ["/admin", "dashboard", "questionnaires", "."],
          includes: ['is_admin', 'is_coach']
        },
        {
          title: $localize`Cuestionarios programados`,
          icon: 'assets/svgs/followup_nav.svg',
          href: ["/admin", "dashboard", "questionnaires", "scheduled", "."],
          includes: ['is_admin', 'is_coach']
        },
        {
          title: $localize`Órdenes`,
          icon: 'assets/svgs/orders_nav.svg',
          href: ["/admin", "orders", "."],
          includes: ['is_admin', 'is_coach', 'is_therapist']
        },
        {
          title: $localize`Citas`,
          icon: 'assets/svgs/appointments_nav.svg',
          href: ["/platform", "appointments", "."],
          includes: [],
          excludes: ['is_intermediary']
        }
      ],
    },
    {
      title: $localize` Integración `,
      icon: 'assets/svgs/integration_nav.svg',
      href: ["/platform", "integration", "."],
      includes: ['is_user', 'is_therapist', 'is_admin', 'is_coach'],
      mobile: true
    },
    {
      title: $localize` Biblioteca `,
      icon: 'assets/svgs/library_nav.svg',
      href: ["/platform", "library", "."],
      includes: ['is_user', 'is_therapist', 'is_admin', 'is_coach']
    },
    {
      title: $localize` Terapia y asesoría médica `,
      icon: 'assets/svgs/therapy_nav.svg',
      href: ["/platform", "therapists", "."],
      mobile: true,
      includes: ['is_user']
    },
    {
      title: $localize` Terapia y asesoría médica `,
      icon: 'assets/svgs/therapy_nav.svg',
      href: ["/platform", "therapists", "."],
      includes: ['is_admin', 'is_coach', 'is_therapist']
    },
    {
      title: $localize`Foro`,
      icon: 'assets/svgs/forum_nav.svg',
      href: ["/platform", "forum", "."],
      includes: []
    },
    {
      title: $localize`Guías especificas`,
      icon: 'assets/svgs/guides_nav.svg',
      href: [],
      includes: [],
      childs: [
        {
          title: $localize` Dosis terapéutica `,
          icon: 'assets/svgs/resources_nav.svg',
          href: ["/platform", "therapeutic-dose", "."],
          includes: ['is_admin', 'is_coach', 'is_therapist', 'can_view_therapeutic_doses']
        },
        {
          title: $localize`Higiene del Sueño`,
          icon: 'assets/svgs/resources_nav.svg',
          href: ["/platform", "sleep-hygiene", "."],
          includes: []
        }
      ]
    },
    {
      title: `FAQs`,
      icon: 'assets/svgs/faqs_nav.svg',
      href: ["/platform", "faqs", "."],
      includes: ['is_user']
    },
    {
      title: $localize`Citas`,
      icon: 'assets/svgs/appointments_nav.svg',
      href: ["/platform", "appointments", "."],
      includes: ['is_user'],
      excludes: ['is_intermediary']
    },
    {
      title: $localize`Mis órdenes`,
      icon: 'assets/svgs/order_nav.svg',
      href: ["/platform", "profile", "orders", "."],
      includes: ['is_user']
    },
    {
      title: $localize`Paquetes de Seguimiento`,
      icon: 'assets/svgs/integration_nav.svg',
      href: ["/platform", "follow-up", "plans", "."],
      includes: ['is_user']
    },
  ];

  get mobileNavLinks() {
    return this.navLinks.filter(i => i.mobile);
  }

  get mobileBottomMenuItems() {
    return this.bottomMenuItems.filter(i => i.mobile);
  }


  public bottomMenuItems: Array<NavigationLinks> = [
    {
      title: $localize`Mensajes`,
      icon: 'assets/svgs/inbox_nav.svg',
      href: ["/platform", "inbox", "."],
      includes: ['is_user'],
      mobile: true,
    },
    {
      title: $localize` Mensajes `,
      icon: 'assets/svgs/inbox_nav.svg',
      href: ["/admin", "inbox", "."],
      mobile: true,
      includes: ['is_coach', 'is_therapist']
    },
    { icon: this.currentUser?.avatar, 
      title: $localize`Mi cuenta`, 
      href: ["/platform", "profile", "edit", "."],
      includes: []
     },
  ];


  @Output() collapsedChange = new EventEmitter<boolean>();

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
    this.collapsedChange.emit(this.isCollapsed);
  }

  signOut() {
    this.authService.logOut();
    this.isCollapsed = true;
  }

  checkRoles(includingRoles: string[], excludingRoles: string[] = []): boolean {
    // Si no hay roles incluidos ni excluidos, permitir por default
    if (!includingRoles.length && !excludingRoles.length) return true;

    // Si el usuario tiene algún rol excluido, no permitir
    if (excludingRoles.some(role => this.roles?.[role])) return false;

    // Si no hay roles incluidos pero tampoco fue excluido, permitir
    if (!includingRoles.length) return true;

    // Permitir solo si tiene al menos uno de los roles incluidos
    return includingRoles.some(role => this.roles?.[role]);
  }
}
